<template>
	<div class="w-100">
		<!-- NAVBAR -->
		<header class="header-fixed bg-white z-index-1040">
			<div class="px-10">
				<div class="row">
					<div class="col-4 col-md-2">
						<img :src="getMerchant.image_url" width="70" :alt="getMerchant.name">
					</div>
					<div class="col-8 col-md-10 text-right">
						<div class="show-desktop">
							<div class="nav float-right mt-2">
								<div :class="{'pt-3':!getMerchant.use_booking_engine && !isNotLogin, 'pt-3 position-relative top--1':!isNotLogin}">
									<div class="ml-4 px-2 my-auto text-center h-fit-content d-inline-block cursor-pointer" @click="callClick">
										<img 
					    				src="../../assets/img/icon/menu-navbar/Calling.png" 
					    				width="24"
					    				:alt="getMerchant.name">
					    				<p class="mb-0 body-1-2 d-inline-block ml-1">{{$t('restaurant.menu.call')}}</p>
									</div>
									<router-link :to="'/'+getMerchant.code+'/feedback'" class="ml-4 px-2 my-auto text-center h-fit-content d-inline-block" @click.native="$trackHomeClick('NAVBAR','Clicked menu review')">
										<img 
					    				src="../../assets/img/icon/menu-navbar/Star.png" 
					    				width="24"
					    				:alt="getMerchant.name">
				    				<p class="mb-0 body-1-2 d-inline-block ml-1">{{$t('restaurant.menu.review')}}</p>
									</router-link>
									<router-link :to="'/'+getMerchant.code+'/gallery'" class="ml-4 px-2 my-auto text-center h-fit-content d-inline-block" @click.native="$trackHomeClick('NAVBAR','Clicked menu gallery')">
										<img 
					    				src="../../assets/img/icon/menu-navbar/Image.png" 
					    				width="24"
					    				:alt="getMerchant.name">
				    				<p class="mb-0 body-1-2 d-inline-block ml-1">{{$t('restaurant.menu.gallery')}}</p>
									</router-link>
									<div class="ml-4 px-2 my-auto text-center h-fit-content d-inline-block cursor-pointer" @click="shareClick()">
										<img 
					    				src="../../assets/img/icon/menu-navbar/Send.png" 
					    				width="24"
					    				:alt="getMerchant.name">
				    				<p class="mb-0 body-1-2 d-inline-block ml-1">{{$t('restaurant.menu.share')}}</p>
									</div>
									<div v-if="isNotLogin" class="ml-4 px-2 pt-3 my-auto text-center h-fit-content d-inline-block cursor-pointer" @click="$openAuthModal({ view: 'login' })">
										<img
					    				src="../../assets/img/icon/menu-navbar/Login.png"
					    				width="24"
					    				:alt="getMerchant.name">
				    				<p class="mb-0 body-1-2 d-inline-block ml-1">{{$t('profile.login.login')}}</p>
									</div>
								</div>
								<router-link :to="'/'+getMerchant.code+'/account'" class="my-auto" v-if="!isNotLogin">
									<div class="ml-4 my-auto text-center box-nav-desktop p-0 d-inline-block cursor-pointer" >
										<img :src="getCurrentUser.avatar" :alt="getMerchant.name" class="w-100 rounded-100 top-0 left-0 object-fit border-2-green" height="50" style="padding:1px">
									</div>
				    			<p class="mb-0 body-1-2 d-inline-block ml-1 width-profile-name text-truncate text-left">{{getCurrentUser.first_name}} {{getCurrentUser.last_name}}</p>
				    		</router-link>
				    		<template>
									<router-link :to="'/'+getMerchant.code+'/booking'" class="ml-4" v-if="Object.keys(getRoomStay).length == 0 && getMerchant.use_booking_engine">
										<button type="button" class="g-btn g-btn-primary g-btn-lg px-5">{{$t('hotel.action.book-now')}}</button>
									</router-link>
								</template>
							</div>
						</div>
						<div class="text-right show-mobile">
							<div class="mt-3 pt-1" @click="headerMobile()">
								<svg width="22" height="14" viewBox="0 0 22 14" fill="none" xmlns="http://www.w3.org/2000/svg">
									<rect x="4" width="18" height="2" rx="1" fill="#222222"/>
									<rect y="6" width="22" height="2" rx="1" fill="#222222"/>
									<rect x="4" y="12" width="18" height="2" rx="1" fill="#222222"/>
								</svg>
							</div>
						</div>
					</div>
				</div>
			</div>
		</header>
		<!-- HEADER MOBILE -->
		<div class="w-100 fixed-top" style="top: 80px;">
			<b-row class="justify-content-center" no-gutters>
			  <b-col cols="12">
					<div class="bg-white px-7 pb-4 w-100 h-100vh pop-up-body z-index-1040 position-relative border-top pt-2" v-if="responsive.mobile_header">
						<div class="mt-2">
							<div :class="{'pt-3':!getMerchant.use_booking_engine && !isNotLogin, 'pt-3 position-relative top--1':!isNotLogin}">
								<div class="d-block px-4 py-3 w-100" @click="callClick">
									<img 
				    				src="../../assets/img/icon/menu-navbar/Calling.png" 
				    				width="24"
				    				:alt="getMerchant.name">
				    				<p class="mb-0 body-1-2 d-inline-block ml-1">{{$t('restaurant.menu.call')}}</p>
								</div>
								<router-link :to="'/'+getMerchant.code+'/feedback'" class="d-block px-4 py-3 w-100" @click.native="$trackHomeClick('NAVBAR','Clicked menu review')">
									<img 
				    				src="../../assets/img/icon/menu-navbar/Star.png" 
				    				width="24"
				    				:alt="getMerchant.name">
			    				<p class="mb-0 body-1-2 d-inline-block ml-1">{{$t('restaurant.menu.review')}}</p>
								</router-link>
								<router-link :to="'/'+getMerchant.code+'/gallery'" class="d-block px-4 py-3 w-100" @click.native="$trackHomeClick('NAVBAR','Clicked menu gallery')">
									<img 
				    				src="../../assets/img/icon/menu-navbar/Image.png" 
				    				width="24"
				    				:alt="getMerchant.name">
			    				<p class="mb-0 body-1-2 d-inline-block ml-1">{{$t('restaurant.menu.gallery')}}</p>
								</router-link>
								<div class="d-block px-4 py-3 w-100" @click="shareClick()">
									<img 
				    				src="../../assets/img/icon/menu-navbar/Send.png" 
				    				width="24"
				    				:alt="getMerchant.name">
			    				<p class="mb-0 body-1-2 d-inline-block ml-1">{{$t('restaurant.menu.share')}}</p>
								</div>
								<div v-if="isNotLogin" class="d-block px-4 py-3 w-100 cursor-pointer" @click="$openAuthModal({ view: 'login' })">
									<img
				    				src="../../assets/img/icon/menu-navbar/Login.png"
				    				width="24"
				    				:alt="getMerchant.name">
			    				<p class="mb-0 body-1-2 d-inline-block ml-1">{{$t('profile.login.login')}}</p>
								</div>
							</div>
							<router-link :to="'/'+getMerchant.code+'/account'" class="my-auto" v-if="!isNotLogin">
								<div class="ml-4 my-auto text-center box-nav-desktop p-0 d-inline-block cursor-pointer" >
									<img :src="getCurrentUser.avatar" :alt="getMerchant.name" class="w-100 rounded-100 top-0 left-0 object-fit border-2-green" height="50" style="padding:1px">
								</div>
			    			<p class="mb-0 body-1-2 d-inline-block ml-1 width-profile-name text-truncate text-left">{{getCurrentUser.first_name}} {{getCurrentUser.last_name}}</p>
			    		</router-link>
				    	<div class="py-3">
				    		<template >
									<router-link :to="'/'+getMerchant.code+'/booking'" class="ml-4" v-if="Object.keys(getRoomStay).length == 0 && getMerchant.use_booking_engine">
										<button type="button" class="g-btn g-btn-primary g-btn-lg px-5">{{$t('hotel.action.book-now')}}</button>
									</router-link>
								</template>
				    	</div>
						</div>
						<div class="mt-8 px-4 text-center">
							<p class="mb-2 font-semibold text-16 text-color-dark">{{getMerchant.address}}</p>
							<p class="mb-2 font-semibold text-16 text-color-dark">
                <a :href="'tel:'+getMerchant.phone" target="_blank" class="color-black">
									<u>{{getMerchant.phone}}</u>
								</a>
							</p>
							<p class="mb-2 font-semibold text-16 text-color-dark">
                <a :href="'mailto:'+getMerchant.email" target="_blank" class="color-black">
									<u>{{getMerchant.email}}</u>
								</a>
							</p>
							<template>
		            <div class="mt-4">
		              <div class="d-inline-block mr-2 mb-2 footer-social-img" v-if="getMerchant.whatsapp_number != '' && getMerchant.whatsapp_number != null">
		                <a :href="'https://api.whatsapp.com/send/?phone='+maskingPlusChar(getMerchant.whatsapp_number)+'&text&app_absent=0'" target="_blank">
		                  <img src="../../assets/img/icon/social/whatsapp.svg" class="cursor-pointer social-img" width="35" title="Whatsapp">
		                  <img src="../../assets/img/icon/social/blur/whatsapp.svg" class="cursor-pointer social-img-blur" width="35" title="Whatsapp">
		                </a> 
		              </div>
		              <div class="d-inline-block mr-2 mb-2 footer-social-img" v-if="getMerchant.facebook_link != '' && getMerchant.facebook_link != null">
                    <a :href="getMerchant.facebook_link" target="_blank">
                      <img src="../../assets/img/icon/social/facebook.svg" class="cursor-pointer social-img" width="35" title="Facebook">
                      <img src="../../assets/img/icon/social/blur/facebook.svg" class="cursor-pointer social-img-blur" width="35" title="Facebook">
                    </a> 
                  </div>
                  <div class="d-inline-block mr-2 mb-2 footer-social-img" v-if="getMerchant.instagram_link != '' && getMerchant.instagram_link != null">
                    <a :href="getMerchant.instagram_link" target="_blank">
                      <img src="../../assets/img/icon/social/instagram.svg" class="cursor-pointer social-img" width="35" title="Instagram">
                      <img src="../../assets/img/icon/social/blur/instagram.svg" class="cursor-pointer social-img-blur" width="35" title="Instagram">
                    </a> 
                  </div>
                  <div class="d-inline-block mr-2 mb-2 footer-social-img" v-if="getMerchant.tiktok_link != '' && getMerchant.tiktok_link != null">
                    <a :href="getMerchant.tiktok_link" target="_blank">
                      <img src="../../assets/img/icon/social/tik-tok.svg" class="cursor-pointer social-img" width="35" title="Tiktok">
                      <img src="../../assets/img/icon/social/blur/tik-tok.svg" class="cursor-pointer social-img-blur" width="35" title="Tiktok">
                    </a> 
                  </div>
                  <div class="d-inline-block mr-2 mb-2 footer-social-img" v-if="getMerchant.tripadvisor_link != '' && getMerchant.tripadvisor_link != null">
                    <a :href="getMerchant.tripadvisor_link" target="_blank">
                      <img src="../../assets/img/icon/social/tripadvisor.svg" class="cursor-pointer social-img" width="35" title="Tripadvisor">
                      <img src="../../assets/img/icon/social/blur/tripadvisor.svg" class="cursor-pointer social-img-blur" width="35" title="Tripadvisor">
                    </a> 
                  </div>
                  <div class="d-inline-block mr-2 mb-2 footer-social-img" v-if="getMerchant.youtube_link != '' && getMerchant.youtube_link != null">
                    <a :href="getMerchant.youtube_link" target="_blank">
                      <img src="../../assets/img/icon/social/youtube.svg" class="cursor-pointer social-img" width="35" title="Youtube">
                      <img src="../../assets/img/icon/social/blur/youtube.svg" class="cursor-pointer social-img-blur" width="35" title="Youtube">
                    </a> 
                  </div>
                  <div class="d-inline-block mr-2 mb-2 footer-social-img" v-if="getMerchant.website != '' && getMerchant.website != null">
                    <a :href="getMerchant.website" target="_blank">
                      <img src="../../assets/img/icon/social/website.svg" class="cursor-pointer social-img" width="35" title="Website">
                       <img src="../../assets/img/icon/social/blur/website.svg" class="cursor-pointer social-img-blur" width="35" title="Website">
                    </a> 
                  </div>
		            </div>
		          </template>
						</div>
					</div>
			  </b-col>
			</b-row>
		</div>
	</div>
</template>
<script>
	import {mapGetters,mapMutations} from 'vuex';
  import PopUpBackground from '@/components/hotel/be/PopUpBackgroundDesktop.vue';
  import Flickity from 'vue-flickity';
  import Footer from '@/components/hotel/Footer.vue';
  import moment from 'moment';
	import {get} from '@/services/index.js'
  import {formatCurrency,formatDate} from '@/utils/index.js'


	export default{
		components:{
			Flickity,
			Footer
		},
		data(){
			return{
				responsive: {
					mobile_header: false,
				},
				freeScrollSlider: {
          initialIndex: 0,
          autoPlay: 4000,
          prevNextButtons: false,
          pageDots: false,
          adaptiveHeight: true,
          draggable: true,
          wrapAround: false,
          contain: false,
          cellAlign: 'left',
          groupCells: false
        },
        room_type:"",
				date:{
					check_in: moment().toDate(),
					check_out: moment(moment().toDate()).add(this.$defaultFilterBE('night'),'d').toDate()
				}
			}
		},
		mounted(){
		},
		computed:{
			...mapGetters(['getMerchant','getCurrentUser','isNotLogin','getRoomStay'])
		},
		methods:{
			formatTime(date){
				let format = "YYYY-MM-DD"
        return moment(date).format(format)
      },
      formatCurrency(data) {
        return formatCurrency(data)
      },
			callClick(){
				this.$emit('callClick')
			},
			detailRoomType(){
				this.$router.push(`/${this.getMerchant.code}/room-type/detail`)
			},
			headerMobile(){
				this.responsive.mobile_header = !this.responsive.mobile_header
			},
			maskingPlusChar(data){
        let return_data = data.substring(0,1)
        return return_data == '+' ? data.substring(1,data.length) : data
      },
		}
	}
</script>
<style scoped>
.show-desktop{
  display: block;
}
.show-mobile{
  display: none;
}
.hide-576px{
  display: block;
}
.header-fixed{
	position: fixed;
	width: 100%;
	top: -1px;
	height: 80.8px;
	background-color: #fff;
	z-index: 9;
}
@media screen and (max-width: 1200px) {
  .show-desktop{
    display: none;
  }
  .show-mobile{
    display: block;
  }
  .px-10{
    padding-left: 3rem;
    padding-right: 3rem;
  }
}
@media screen and (max-width: 576px) {
	.hide-576px{
	  display: none;
	}
  .px-10{
    padding-left: 24px;
    padding-right: 24px;
  }
  .text-20-m{
  	font-size: 20px!important;
  }
  .text-17-m{
  	font-size: 17px!important;
  }
  .text-14-m{
  	font-size: 14px!important;
  }
  .room-type-border-m{
  	border: 1px solid #ddd;
  	padding-bottom: 0px!important;
  	border-radius: 6px;
  }
  .room-type-desc-m{
  	padding: 16px!important;
  }
  .p-0-m{
  	padding: 0!important;
  }
  .h-270px-m{
  	height: 270px!important;
  }
  .px-7{
  	padding-left: 0!important;
    padding-right: 0!important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/hotel/HeaderBE.vue